import React, { useCallback } from 'react';
import clsx from 'clsx';
import { useDropzone } from 'react-dropzone';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { IDropzone } from './types';

const useStyles = makeStyles((theme) => ({
    root: {},
    dragActive: {
        backgroundColor: theme.palette.action.active,
        opacity: 0.5,
    },
}));

const DEFAULT_MEDIA_TYPES =
    'image/jpeg, image/gif, image/png, application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,.csv,text/csv,application/msword,.doc,.docx,.Xsls';

export const Dropzone = ({
    handleAdd,
    multiple = false,
    types,
    className,
    children,
    ...rest
}: IDropzone) => {
    const classes = useStyles();

    const handleDrop = useCallback(
        (acceptedFiles: File[]) => handleAdd(acceptedFiles),
        [handleAdd]
    );

    const { getRootProps, getInputProps } = useDropzone({
        onDrop: handleDrop,
        accept: types || DEFAULT_MEDIA_TYPES,
        multiple,
    });

    return (
        <Box className={clsx(classes.root, className)} {...rest}>
            <Box {...getRootProps()}>
                <input {...getInputProps()} />
                {children}
            </Box>
        </Box>
    );
};
